import backgroundVideo from "../../assets/images/backgroundProducts.mp4";
import "./style.css";
import { img13, img14, img15, img16 } from "../../assets/images/osprey"
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const ospreyDetails = {
    name: "Osprey (Enterprise Resource Planning)",
    description: "This ERP system is a comprehensive business management solution designed to streamline operations with modules for Project Management, Work Management, CRM, Finance, and HR. It centralizes processes, automates workflows, and enhances productivity for businesses.",
    images: [ img13, img14, img15, img16 ],
}

const InstituteManagementSystem = () => {
    const settings = {
        className: "center",
        centerMode: true,
        infinite: true,
        centerPadding: "60px",
        slidesToShow: 1,
        speed: 500
      };
    return (
        <div className="w-full relative h-full">
      {/* Background Section */}
      <section id="heading" className="relative flex">
        {/* Background Video */}
        <video
          className="absolute inset-0 w-full h-full object-cover"
          src={backgroundVideo}
          autoPlay
          loop
          muted
          style={{ opacity: "0.25" }}
        />

        {/* Heading Content */}
        <div className="relative max-w-7xl mx-auto flex flex-col items-center justify-center h-screen z-10">
          <h1 className="text-4xl lg:text-5xl font-bold text-center text-white">
            <span className="gradient-headings">{ospreyDetails.name}</span>
          </h1>
          <p className="text-xl lg:text-2xl text-white mt-6 mx-auto max-w-4xl px-4 text-justify md:text-center">
            This ERP system is a comprehensive business management solution designed to streamline operations with modules for Project Management, Work Management, CRM, Finance, and HR. 
          </p>
        </div>
      </section>

      {/* Description Section */}
      <section className="pb-10 px-4 md:px-8 bg-gradient-to-r from-slate-950/80 via-slate-950/90 to-slate-950/100">
        <div className="container mx-auto flex flex-col-reverse md:flex-col   gap-10 xl:gap-16 items-center">
          <div className="text-base lg:text-xl text-white px-4 xl:mt-24">
            <p className="text-justify">{ospreyDetails.description}</p>
          </div>
          <div className="w-full px-4 slider-container">
            <Slider {...settings}>
              {ospreyDetails.images.map((image, index) => (
                <div key={index} className="">
                  <img
                    src={image}
                    alt="product images"
                    className="w-full h-auto rounded-lg shadow-lg object-cover"
                  />
                </div>
              ))}
            </Slider>
          </div>
        </div>
      </section>


      
    </div>
    )
}

export default InstituteManagementSystem